/*
 * ثابت‌های مشترک رابط کاربری.
 *
 * فهرست نوع ادیت پیش‌تر در دو جا کپی شده بود (فرم پذیرش و فرم ویرایش مدیر)؛
 * افزودن «جراحی» نشان داد که این تکرار دیر یا زود از هم واگرا می‌شود.
 * مرجع اصلی همچنان api/constants.py است — این فایل باید با آن هم‌گام بماند.
 */

/*
 * این فهرست عیناً از خدمات تصویربرداریِ «پذیرش پرتو» می‌آید و شناسه‌ی هر نوع
 * == شناسه‌ی همان سرویس در پرتو است، تا پلِ داده بدون اصلاح دستی یک‌به‌یک
 * نگاشت کند. منبعِ واحدِ حقیقت، api/edit_types.json در بک‌اند است؛ این فهرست
 * باید با آن هم‌گام بماند (خدمات غیرگزارشی مثل سی‌دی/پرینت/گان وارد نمی‌شوند).
 * برای بازتولید: integration/parto/generate_edit_types.py.
 *
 * `retired: true` یعنی آن گرافی ادیت و گزارش نمی‌خواهد: از فهرست انتخاب بیرون
 * است ولی عنوانش می‌ماند تا پرونده‌های قدیمیِ همان نوع درست نمایش داده شوند.
 * برای هر فهرست انتخابی از SELECTABLE_EDIT_TYPES استفاده کنید، نه EDIT_TYPES.
 */
export const EDIT_TYPES = [
  { id: 12762013, name: 'واترز/کالدول', retired: true },
  { id: 12763016, name: 'TMJ یک طرفه', retired: true },
  { id: 12763017, name: 'TMJ یک طرفه دوفیلم', retired: true },
  { id: 12763024, name: 'پری اپیکال سری کامل 14 کلیشه', retired: true },
  { id: 12763025, name: 'پری اپیکال 10 کلیشه', retired: true },
  { id: 12763027, name: 'بایت وینگ', retired: true },
  { id: 12763037, name: 'ریورس تاون / SMV' },
  { id: 12763039, name: 'نمای مایل مندیبل یک طرف' },
  { id: 12763040, name: 'لترال سفالوگرام', retired: true },
  { id: 12763043, name: 'cbct دو فک کامل' },
  { id: 12763044, name: 'cbct سه نیم فک' },
  { id: 12763045, name: 'cbct دو نیم فک' },
  { id: 12763046, name: 'cbct نیم فک' },
  { id: 12763060, name: 'سی تی اسکن بررسی مفصل گیجگاهی فکی دو طرفه' },
  { id: 12763063, name: 'CBCT ضایعات استخوانی' },
  { id: 12764063, name: 'سفالوگرام PA', retired: true },
  { id: 1276174226, name: 'سی تی اسکن اسپیرال اوربیت دوجهت بدون تزریق' },
  { id: 1276240921, name: 'سی تی اسکن عقل یک طرفه' },
  { id: 1276270895, name: 'سی تی سینوس و بینی یک جهته' },
  { id: 1276288755, name: 'TMJ سی تی اسکن دوطرفه' },
  { id: 1276296003, name: 'پری اپیکال', retired: true },
  { id: 1276316167, name: 'adenoid' },
  { id: 1276441469, name: 'آنالیز سفالومتری' },
  { id: 1276467867, name: 'پری اپیکال آزاد', retired: true },
  { id: 1276471525, name: 'سی تی اسکن شکستگی ریشه/اندو' },
  { id: 1276490354, name: 'سن استخوانی' },
  { id: 1276525578, name: 'سی تی اسکن عقل دو طرفه' },
  { id: 1276538484, name: 'PNS' },
  { id: 1276582112, name: 'پانورکس', retired: true },
  { id: 1276596322, name: 'بایت وینگ آزاد', retired: true },
  { id: 1276633356, name: 'رادیوگرافی مفصل تمپرومندیبولر با دهان باز و بسته', retired: true },
  { id: 1276674870, name: 'سی تی اسکن کانین تا کانین' },
  { id: 1276691812, name: 'پانورکس-تأمین اجتماعی', retired: true },
  { id: 1276697636, name: 'سی تی اسکن بینی یا سینوس' },
  { id: 1276704135, name: 'سی تی اسپیرال منطقه ماگزیلوفاشیال بدون تزریق' },
  { id: 1276716978, name: 'استخوان بینی چپ و راست' },
  { id: 1276827089, name: 'cbctتک دندان' },
  { id: 1276828725, name: 'رادیوگرافی فیلم اکلوزال', retired: true },
  { id: 1276883470, name: 'سیالوگرافی یک طرفه هر غده بزاقی' },
  { id: 1276933356, name: 'سی تی اسپیرال صورت و سینوس دوجهت بدون تزریق' },
];

/** آنچه هنگام ثبت یا ویرایش پرونده قابل انتخاب است — هم‌تراز با بک‌اند. */
export const SELECTABLE_EDIT_TYPES = EDIT_TYPES.filter((type) => !type.retired);

/** قالب‌هایی که برای نسخه‌ی پزشک پذیرفته می‌شوند — هم‌تراز با سریالایزر سرور. */
export const PRESCRIPTION_TYPES = [
  'image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif',
  'image/tiff', 'application/pdf',
];

export const PRESCRIPTION_MAX_BYTES = 15 * 1024 * 1024;
